<main class="main-content">
    <div>
        <div class="bg-brand-purple-50 p-8">
            <div class="flex items-center justify-between">
                <h2 class="page-title">Listas salvas</h2>
                <button class="text-brand-primary">
                    <span class="material-symbols-outlined filled">
                        view_week
                    </span>
                </button>
            </div>
        </div>
        <div class="main-content__area">
            <app-carregando 
                [showCarregando]="isLoading" 
                [isChart]="false"
                containerHeight="50vh"
                spinnerSize="40px">
            </app-carregando>
            
            <div class="py-5" [class.hidden]="isLoading">
                <div class="table__wrapper">
                    <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="table table-hover">
                        
                    </table>
                </div>
            </div>
        </div>
    </div>
</main>